import axios from 'axios' //引用axios
import router from '../router/index'
import store from '../store/index'


let options = {
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 10000, // request timeout

}
// The server-side needs a full url to works
if (process.server) {
  options.baseURL = `http://${process.env.HOST || '127.0.0.1'}:${process.env.PORT || 3000}`
}

// create an axios instance
const service = axios.create(options)

const CancelToken = service.CancelToken;


// Add a request interceptor
service.interceptors.request.use(function (config) {
    return config;
}, function (error) {
    return Promise.reject(error);
});

service.interceptors.response.use((response) => {
    // 拦截/api/getSystemList接口响应数据 添加公司新闻/行业新闻的数据
    if (response.config.url === '/api/getSystemList') {
        if (response.data.SystemList && response.data.SystemList.CFND_HighTrail !== undefined) {
            response.data.SystemList.CFND_HighTrail.tableInfo = {};
            response.data.SystemList.CFND_HighTrail.tableInfo.报刊财经新闻基本信息 = require("../../static/json/报刊财经新闻基本信息.json")
            response.data.SystemList.CFND_HighTrail.tableInfo.报刊财经新闻相似度 =  require("../../static/json/报刊财经新闻相似度.json")
            response.data.SystemList.CFND_HighTrail.tableInfo.报刊财经新闻量化统计 =  require("../../static/json/报刊财经新闻量化统计.json")
            response.data.SystemList.CFND_HighTrail.tableInfo.网络新闻量化统计_按交易时间 =  require("../../static/json/网络新闻量化统计_按交易时间.json")
            response.data.SystemList.CFND_HighTrail.tableInfo.网络新闻量化统计_按自然日 =  require("../../static/json/网络新闻量化统计_按自然日.json")
            response.data.SystemList.CFND_HighTrail.tableInfo.网络财经新闻基本信息 =  require("../../static/json/网络财经新闻基本信息.json")
            response.data.SystemList.CFND_HighTrail.tableInfo.网络财经新闻相似度 =  require("../../static/json/网络财经新闻相似度.json")
        }
    }
    if (response.data && response.data.msg==='未登录，无法访问') {
        store.commit('setUserInfo',{
            UserName: ''
        });
    }else{
        return response;
    }
}, function (error) {
    return Promise.reject(error);
});

export default service

